import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=003f8ab8&scoped=true&"
import script from "./contact.vue?vue&type=script&setup=true&lang=js&"
export * from "./contact.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./contact.vue?vue&type=style&index=0&id=003f8ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003f8ab8",
  null
  
)

export default component.exports